import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from 'app/services/permission.service';
import { Observable, of } from 'rxjs';

/**
 * Гард маршрута по праву новой ролевой системы (IC-2972). Требуемый код права
 * передаётся через `data: { permission: <code> }` либо `data: { permissions: [...] }`.
 * Для массива по умолчанию требуются все права; `permissionMode: 'any'` включает OR.
 * Сисадмин проходит всегда (учтено в селекторах). Пришёл на смену ролевым гардам
 * (ManagerGuard/AdminGuard), которые не видели прав новой системы.
 */
@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(private readonly permissions: PermissionService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const permission = route.data?.['permission'] as number | undefined;
    const permissionCodes = route.data?.['permissions'] as number[] | undefined;
    if (permission != null) {
      return this.permissions.hasPermission$(permission);
    }
    if (!permissionCodes?.length) {
      return of(true);
    }

    return route.data?.['permissionMode'] === 'any'
      ? this.permissions.hasAnyPermission$(permissionCodes)
      : this.permissions.hasAllPermissions$(permissionCodes);
  }
}
